<template>
    <div class="qksm qksm10">
        <h4>十二、一般公共预算机关运行经费支出决算情况说明</h4>
            <p>
                {{$parent.year}}年度机关运行经费支出决算{{isMoney(T12.总计)}}万元。
                <span class="hide_pdf">
                    （去年决算数<reason type="money" classname="qksm money editLast" name="T12总计去年" v-model:value="T12['总计_last']"></reason>万元）
                </span>
                <span v-if="num(T12.总计).toFixed(2)==num(T12['总计_last']).toFixed(2)">
                    与上年决算数相同。
                </span>
                <span v-else>
                    与上年相比，{{growthValueText(T12.总计,T12['总计_last'])}}万元
                    <span v-if="num(T12['总计_last'])==0">
                        ，（上年决算数为0万元，无法计算增减比率）。
                    </span>
                    <span v-else>
                        ，{{growthRatioText(T12.总计,T12['总计_last'])}}。
                    </span>
                    变动原因：<reason type="textarea" classname="qksm widest because" name="T12原因" v-model:value="qksm['T12原因']"></reason>
                </span>
            </p>
    </div>
</template>
<script>
    import reason from "@/components/reason.vue";
    export default {
        name: "qksm10",
        props: {
            T12: {
                type: Object,
                default: "",
            },
        },
        data() {
            var qksm = this.$store.state.divData.qksm;
            if (qksm['T12总计去年'])
                this.T12['总计_last'] = qksm['T12总计去年'];
            return {
                isPdf: this.$parent.isPdf,
                qksm: qksm,
            }
        },
        components: {
            reason,
        },
    };
</script>
